import _defineProperty2 from "C:\\Building-application\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "C:\\Building-application\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
import _toConsumableArray from "C:\\Building-application\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty2(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

import _Reflect$construct from "@babel/runtime-corejs3/core-js-stable/reflect/construct";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/reduce";
import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/createClass";
import _assertThisInitialized from "@babel/runtime-corejs3/helpers/assertThisInitialized";
import _inherits from "@babel/runtime-corejs3/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs3/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs3/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = _Reflect$construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !_Reflect$construct) return false;
  if (_Reflect$construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(_Reflect$construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { BrowserRouter, MemoryRouter, Route, Router } from 'react-router-dom';
import { createBrowserHistory, createMemoryHistory } from 'history';
import _ from 'lodash';
import { GlobalizationProvider, TranslatorContext } from '@jutro/locale';
import { log, warning } from '@jutro/logger';
import { AuthProvider, SecureRoute } from '@jutro/auth';
import { routeConfirmationModal, RouteTracker, PageHead } from '@jutro/router';
import { SkipNav, Loader, ModalNextProvider, ToastProvider } from '@jutro/components';
import { ServiceManager } from '@jutro/services';
import { BreakpointTracker } from '@jutro/layout';
import { getConfigValue } from '@jutro/config';
import { DevErrorBoundary } from './DevErrorBoundary';
import { isTest } from './env';
import { MessagesLoader } from './MessagesLoader';
import { LanguagesLoader } from './LanguagesLoader';

function composeErrorBoundary(ErrorBoundary) {
  return function (body) {
    return React.createElement(ErrorBoundary, null, body);
  };
}

export var ApplicationRoot = function (_Component) {
  _inherits(ApplicationRoot, _Component);

  var _super = _createSuper(ApplicationRoot);

  function ApplicationRoot(props) {
    var _this;

    _classCallCheck(this, ApplicationRoot);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "getRouterHistory", function () {
      var _this$props = _this.props,
          routerHistory = _this$props.routerHistory,
          routerBasename = _this$props.routerBasename;

      if (routerHistory) {
        return routerHistory;
      }

      if (isTest()) {
        return createMemoryHistory({
          getUserConfirmation: routeConfirmationModal
        });
      }

      return createBrowserHistory({
        basename: routerBasename,
        getUserConfirmation: routeConfirmationModal
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onLanguageChange", function _callee(language) {
      var refreshOnLocaleChange;
      return _regeneratorRuntime().async(function _callee$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              refreshOnLocaleChange = _this.props.refreshOnLocaleChange;

              if (!refreshOnLocaleChange) {
                _context2.next = 4;
                break;
              }

              window.location.reload();
              return _context2.abrupt("return", {});

            case 4:
              _this.setState(function (state) {
                return {
                  currentLanguage: language,
                  localeLoaded: state.localeLoaded && state.currentLanguage === language
                };
              });

              return _context2.abrupt("return", undefined);

            case 6:
            case "end":
              return _context2.stop();
          }
        }
      }, null, null, null, Promise);
    });

    _defineProperty(_assertThisInitialized(_this), "onLoadMessages", function (messages) {
      _this.setState({
        localeLoaded: true,
        messages: messages
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onLoadLanguages", function () {
      _this.setState({
        languagesLoaded: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderWithRouter", function (children) {
      var _this$props2 = _this.props,
          RouterProp = _this$props2.Router,
          routerBasename = _this$props2.routerBasename;

      if (RouterProp) {
        return React.createElement(RouterProp, {
          basename: routerBasename,
          getUserConfirmation: routeConfirmationModal
        }, children);
      }

      return React.createElement(Router, {
        history: _this.routerHistory,
        basename: routerBasename
      }, children);
    });

    _defineProperty(_assertThisInitialized(_this), "renderRequiredComponents", function () {
      var _this$props3 = _this.props,
          trackingCallback = _this$props3.trackingCallback,
          _this$props3$modalPro = _this$props3.modalProviderId,
          modalProviderId = _this$props3$modalPro === void 0 ? 'modalProvider' : _this$props3$modalPro,
          disableModalProvider = _this$props3.disableModalProvider;
      return React.createElement(React.Fragment, null, React.createElement(RouteTracker, {
        track: trackingCallback
      }), React.createElement(ToastProvider, null), !disableModalProvider && React.createElement(ModalNextProvider, {
        id: modalProviderId
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "renderPageHead", function (translator) {
      return React.createElement(PageHead, {
        currentLanguage: _this.state.currentLanguage,
        appName: translator(_this.props.appName),
        appDescription: translator(_this.props.appName)
      });
    });

    var localeService = ServiceManager.getService('locale');
    var currentLocale = localStorage.selectedLocale || localeService.getCurrentLocale();
    var currentLanguage = localStorage.selectedLanguage || localeService.getCurrentLanguage();
    _this.state = {
      currentLocale: currentLocale,
      currentLanguage: currentLanguage,
      localeLoaded: false,
      languagesLoaded: false,
      messages: {}
    };
    _this.routerHistory = _this.getRouterHistory();
    _this.authEnabled = getConfigValue('JUTRO_AUTH_ENABLED', false);
    return _this;
  }

  _createClass(ApplicationRoot, [{
    key: "getHOCs",
    value: function getHOCs() {
      var _this$props4 = this.props,
          errorBoundary = _this$props4.errorBoundary,
          rootHOCs = _this$props4.rootHOCs;
      var hocs = [];

      if (rootHOCs) {
        if (_.isArray(rootHOCs)) {
          hocs = _toConsumableArray(rootHOCs);
        } else {
          hocs.push(rootHOCs);
        }
      }

      hocs.push(composeErrorBoundary(errorBoundary));
      return hocs;
    }
  }, {
    key: "applyHOCs",
    value: function applyHOCs(body) {
      var _context;

      return _reduceInstanceProperty(_context = this.getHOCs()).call(_context, function (jsx, hocFunc) {
        if (_.isFunction(hocFunc)) {
          return hocFunc(jsx);
        }

        log.warning('rootHOC is not a function. HOC will not be applied');
        return jsx;
      }, body);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          currentLocale = _this$state.currentLocale,
          localeLoaded = _this$state.localeLoaded,
          languagesLoaded = _this$state.languagesLoaded,
          messages = _this$state.messages,
          currentLanguage = _this$state.currentLanguage;
      var _this$props5 = this.props,
          Main = _this$props5.main,
          onAuthSessionExpired = _this$props5.onAuthSessionExpired,
          messageLoader = _this$props5.messageLoader,
          coreMessageLoader = _this$props5.coreMessageLoader,
          intlTextComponent = _this$props5.intlTextComponent;

      var renderMain = function renderMain(routeProps) {
        return React.createElement(React.Fragment, null, _this2.renderRequiredComponents(), React.createElement(Main, _extends({}, routeProps, {
          hasLoaded: localeLoaded
        })));
      };

      var renderBody = function renderBody(_ref) {
        var _ref$isAuthenticated = _ref.isAuthenticated,
            isAuthenticated = _ref$isAuthenticated === void 0 ? true : _ref$isAuthenticated,
            routeProps = _objectWithoutProperties(_ref, ["isAuthenticated"]);

        return React.createElement(GlobalizationProvider, {
          messages: messages,
          defaultLocale: currentLocale,
          onLanguageChange: _this2.onLanguageChange,
          intlTextComponent: intlTextComponent
        }, React.createElement(React.Fragment, null, isAuthenticated && React.createElement(MessagesLoader, {
          messageLoader: messageLoader,
          coreMessageLoader: coreMessageLoader,
          language: currentLanguage,
          onLoad: _this2.onLoadMessages
        }), isAuthenticated && React.createElement(LanguagesLoader, {
          onLoad: _this2.onLoadLanguages
        }), localeLoaded && React.createElement(TranslatorContext.Consumer, null, _this2.renderPageHead), React.createElement(Loader, {
          loaded: isAuthenticated && localeLoaded && languagesLoaded
        }, React.createElement(React.Fragment, null, React.createElement(SkipNav, null), React.createElement(BreakpointTracker, null, renderMain(routeProps))))));
      };

      var routes = this.authEnabled && !this.props.disableAuthForApplicationRoot ? React.createElement(AuthProvider, {
        onAuthSessionExpired: onAuthSessionExpired
      }, React.createElement(SecureRoute, {
        path: "/",
        render: function render(_ref2) {
          var auth = _ref2.auth,
              routeProps = _objectWithoutProperties(_ref2, ["auth"]);

          return renderBody(_objectSpread({
            isAuthenticated: auth.authenticated
          }, routeProps));
        }
      })) : React.createElement(Route, {
        path: "/"
      }, function (routeProps) {
        return renderBody(routeProps);
      });
      return this.applyHOCs(this.renderWithRouter(routes));
    }
  }]);

  return ApplicationRoot;
}(Component);

_defineProperty(ApplicationRoot, "propTypes", {
  messageLoader: PropTypes.func,
  coreMessageLoader: PropTypes.func,
  intlTextComponent: PropTypes.string,
  errorBoundary: PropTypes.func,
  main: PropTypes.func.isRequired,
  trackingCallback: PropTypes.func,
  Router: PropTypes.oneOf([BrowserRouter, MemoryRouter]),
  routerHistory: PropTypes.object,
  routerBasename: PropTypes.string,
  rootHOCs: PropTypes.oneOfType([PropTypes.func, PropTypes.arrayOf(PropTypes.func)]),
  refreshOnLocaleChange: PropTypes.bool,
  onAuthSessionExpired: PropTypes.func
});

_defineProperty(ApplicationRoot, "defaultProps", {
  messageLoader: function messageLoader(locale) {
    warning("No application specific message resources loaded for locale: ".concat(locale));
    return {};
  },
  coreMessageLoader: function coreMessageLoader(locale) {
    warning("No core message resources loaded for locale: ".concat(locale));
    return {};
  },
  errorBoundary: DevErrorBoundary,
  routerBasename: getConfigValue('JUTRO_ROUTER_BASENAME', ''),
  refreshOnLocaleChange: false
});

ApplicationRoot.__docgenInfo = {
  componentName: "ApplicationRoot",
  packageName: "@jutro/app",
  description: "A root-level component that takes care of application-level\nconcerns for you:\n-- internationalization\n-- routing\n-- error handling (uncaught)\nIf the application requires a custom HOC, rootHOCs render prop\ncan be used, e.g. <ApplicationRoot rootHOCs={composeRedux(store)} />.\nArray of HOCs are applied in order starting with first to last and then\nErrorBoundary is added.",
  displayName: "ApplicationRoot",
  methods: [{
    name: "getRouterHistory",
    docblock: "If the router history prop is provided, use it. Otherwise\ndefault to the memory router for test, or browser router for all other cases\n\n@returns {object} - The router history to use",
    modifiers: [],
    params: [],
    returns: {
      description: "The router history to use",
      type: {
        name: "object"
      }
    },
    description: "If the router history prop is provided, use it. Otherwise\ndefault to the memory router for test, or browser router for all other cases"
  }, {
    name: "onLanguageChange",
    docblock: "Refreshes the browser if the option is enabled.\nOtherwise loads the new messages, and sets the language\n\n@param {string} language - the new language\n\n@returns {object} - Newly loaded messages",
    modifiers: ["async"],
    params: [{
      name: "language",
      description: "the new language",
      type: {
        name: "string"
      },
      optional: false
    }],
    returns: {
      description: "Newly loaded messages",
      type: {
        name: "object"
      }
    },
    description: "Refreshes the browser if the option is enabled.\nOtherwise loads the new messages, and sets the language"
  }, {
    name: "onLoadMessages",
    docblock: null,
    modifiers: [],
    params: [{
      name: "messages",
      optional: undefined,
      type: null
    }],
    returns: null
  }, {
    name: "onLoadLanguages",
    docblock: null,
    modifiers: [],
    params: [],
    returns: null
  }, {
    name: "getHOCs",
    docblock: "Returns an array of higher-order components.\n\n@returns {Array<Function>} - The array of higher-order components",
    modifiers: [],
    params: [],
    returns: {
      description: "The array of higher-order components",
      type: {
        name: "Array",
        elements: [{
          name: "Function"
        }]
      }
    },
    description: "Returns an array of higher-order components."
  }, {
    name: "renderWithRouter",
    docblock: "Render the children with the correct router. If a custom Router prop is present\nuse it as the router. Otherwise use the base React Router with a custom history.\n\n@param {React.ReactElement} children - router children to render\n@returns {React.ReactElement} - the rendered router",
    modifiers: [],
    params: [{
      name: "children",
      description: "router children to render",
      type: {
        name: "React.ReactElement"
      },
      optional: false
    }],
    returns: {
      description: "the rendered router",
      type: {
        name: "React.ReactElement"
      }
    },
    description: "Render the children with the correct router. If a custom Router prop is present\nuse it as the router. Otherwise use the base React Router with a custom history."
  }, {
    name: "renderRequiredComponents",
    docblock: "Render any additional components required for Jutro app functionality\n\n@returns {React.ReactElement} - The fragment containing the additional components",
    modifiers: [],
    params: [],
    returns: {
      description: "The fragment containing the additional components",
      type: {
        name: "React.ReactElement"
      }
    },
    description: "Render any additional components required for Jutro app functionality"
  }, {
    name: "applyHOCs",
    docblock: "Applies the HOCs to the body of the application.\n\n@param {React.ReactElement} body - The application body\n@returns {React.ReactElement} - The wrapped application body",
    modifiers: [],
    params: [{
      name: "body",
      description: "The application body",
      type: {
        name: "React.ReactElement"
      },
      optional: false
    }],
    returns: {
      description: "The wrapped application body",
      type: {
        name: "React.ReactElement"
      }
    },
    description: "Applies the HOCs to the body of the application."
  }, {
    name: "renderPageHead",
    docblock: "Renders a react-helmet element that builds a localized titleTemplate and description, and other meta tags.\n\n@param {Function} translator - The localization translator function\n@returns {React.ReactElement} - The Helmet header element",
    modifiers: [],
    params: [{
      name: "translator",
      description: "The localization translator function",
      type: {
        name: "Function"
      },
      optional: false
    }],
    returns: {
      description: "The Helmet header element",
      type: {
        name: "React.ReactElement"
      }
    },
    description: "Renders a react-helmet element that builds a localized titleTemplate and description, and other meta tags."
  }],
  actualName: "ApplicationRoot",
  props: {
    messageLoader: {
      type: {
        name: "func"
      },
      required: false,
      description: "",
      defaultValue: {
        value: "locale => {\n    warning(\n        `No application specific message resources loaded for locale: ${locale}`\n    );\n    return {};\n}",
        computed: false
      }
    },
    coreMessageLoader: {
      type: {
        name: "func"
      },
      required: false,
      description: "",
      defaultValue: {
        value: "locale => {\n    warning(`No core message resources loaded for locale: ${locale}`);\n    return {};\n}",
        computed: false
      }
    },
    intlTextComponent: {
      type: {
        name: "string"
      },
      required: false,
      description: ""
    },
    errorBoundary: {
      type: {
        name: "func"
      },
      required: false,
      description: "",
      defaultValue: {
        value: "DevErrorBoundary",
        computed: true
      }
    },
    main: {
      type: {
        name: "func"
      },
      required: true,
      description: ""
    },
    trackingCallback: {
      type: {
        name: "func"
      },
      required: false,
      description: ""
    },
    Router: {
      type: {
        name: "enum",
        value: [{
          value: "import { BrowserRouter, MemoryRouter, Route, Router } from 'react-router-dom';",
          computed: true
        }, {
          value: "import { BrowserRouter, MemoryRouter, Route, Router } from 'react-router-dom';",
          computed: true
        }]
      },
      required: false,
      description: ""
    },
    routerHistory: {
      type: {
        name: "object"
      },
      required: false,
      description: ""
    },
    routerBasename: {
      type: {
        name: "string"
      },
      required: false,
      description: "",
      defaultValue: {
        value: "getConfigValue('JUTRO_ROUTER_BASENAME', '')",
        computed: true
      }
    },
    rootHOCs: {
      type: {
        name: "union",
        value: [{
          name: "func"
        }, {
          name: "arrayOf",
          value: {
            name: "func"
          }
        }]
      },
      required: false,
      description: ""
    },
    refreshOnLocaleChange: {
      type: {
        name: "bool"
      },
      required: false,
      description: "",
      defaultValue: {
        value: "false",
        computed: false
      }
    },
    onAuthSessionExpired: {
      type: {
        name: "func"
      },
      required: false,
      description: ""
    }
  }
};